import {
	RecentlyViewedAction,
	RecentlyViewedState,
	RECENTLY_VIEWED_ACTION_TYPES,
} from './types'
import { MAX_NUMBER_OF_RECENTLY_VIEWED_PATIENTS } from '../../../constants/common'

const initialViewedPatientsList = localStorage.getItem('viewed_patients')

const initialState: RecentlyViewedState = {
	list: initialViewedPatientsList
		? JSON.parse(initialViewedPatientsList)
		: [],
}

export default (
	state: RecentlyViewedState = initialState,
	action: RecentlyViewedAction
): RecentlyViewedState => {
	switch (action.type) {
		case RECENTLY_VIEWED_ACTION_TYPES.SET_VIEWED: {
			const newViewedList = [action.payload, ...state.list].slice(
				0,
				MAX_NUMBER_OF_RECENTLY_VIEWED_PATIENTS - 1
			)

			localStorage.setItem(
				'viewed_patients',
				JSON.stringify(newViewedList)
			)

			return {
				...state,
				list: newViewedList,
			}
		}
		default: {
			return state
		}
	}
}
